import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { RoleDetail, CreateRoleDto } from '@/types/settings';

export const useCreateRole = createMutationHook<RoleDetail, CreateRoleDto>({
  mutationFn: (dto) =>
    apiPost<RoleDetail, CreateRoleDto>(operationsClient, settingsEndpoints.roles(), dto),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: settingsKeys.roles() });
    toast.success('Role created');
  },
});
